import React, { useCallback, useRef, useState } from "react";

export function estimateDelay(message: string, speedWps = 3): number {
  const words = message.trim().split(/\s+/).length;
  return Math.max(1500, (words / speedWps) * 1000);
}
// TODO: cover by units
export function useLiveAnnouncer({
  mode = "assertive",
}: {
  mode?: "polite" | "assertive";
} = {}) {
  const [currentMessage, setCurrentMessage] = useState("");
  const queueRef = useRef<string[]>([]);
  const isAnnouncingRef = useRef(false);
  const regionRef = useRef<HTMLDivElement | null>(null);

  const announce = useCallback((message: string, delayOverride?: number) => {
    queueRef.current.push(message);

    const processQueue = async () => {
      if (isAnnouncingRef.current || queueRef.current.length === 0) return;
      isAnnouncingRef.current = true;

      const nextMessage = queueRef.current.shift();
      if (!nextMessage) return;

      setCurrentMessage("");
      await new Promise((r) => setTimeout(r, 100));

      setCurrentMessage(nextMessage);

      const estimatedDelay =
        delayOverride || estimateDelay(nextMessage);

      await new Promise((r) => setTimeout(r, estimatedDelay));
      isAnnouncingRef.current = false;

      processQueue();
    };

    processQueue();
  }, []);

  const LiveRegion = useCallback(() => (
    <div
      ref={regionRef}
      aria-live={mode}
      aria-atomic="true"
      style={{
        position: "absolute",
        left: "-9999px",
        width: "1px",
        height: "1px",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
    >
      {currentMessage}
    </div>
  ), [currentMessage, mode]);

  return { announce, LiveRegion };
}
